import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-h1',
    templateUrl: './h1.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class H1Component implements OnInit {
  constructor() {}

  ngOnInit() {}
}
